import { ApiCall } from '../ApiClient';
import { BoardLiteData, RangeResult, ResultData, UserLiteData } from '../ApiTypes';
import { dateTransformer } from '../ApiUtil';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

export interface NotificationData {
    id: string;
    accountId: string;
    type: string;
    content: string;
    entity?: { id: string };
    sender: UserLiteData;
    board?: BoardLiteData;
    data?: any;
    readAt?: Date;
    createdAt: Date;
};

export interface NotificationListParams {
    sort: string;
    startAt: number;
    maxResults: number;
};

export interface NotificationCountParams {
    status?: 'read' | 'unread' | 'all';
};

export const notificationsEndpoints = {

    list: (params: NotificationListParams) => get<RangeResult<NotificationData>>({
        path: '/notifications.list',
        query: { ...params },
        transform: dateTransformer(),
    }),

    clear: () => post<ResultData>({
        path: '/notifications.clear',
    }),

    count: (params: NotificationCountParams) => get<{ count: number }>({
        path: '/notifications.count',
        query: { ...params },
        transform: dateTransformer(),
    }),

    markAsRead: (ids: string[] | 'all') => post<ResultData>({
        path: '/notifications.markAsRead',
        body: { ids },
        transform: dateTransformer(),
    }),
};
